import DefaultTaskDetailApp from "defaultTask/Detail/App";
import DefaultTaskListApp from "defaultTask/List/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const defaultTaskRoute: RouteObject = {
  path: "defaulttasks",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: DefaultTaskListApp,
  }, {
    path: "detail/:key",
    loader: () => viewModel,
    Component: DefaultTaskDetailApp,
  }]
};